module.exports = __webpack_public_path__ + "static/media/productCategory-07.58d5f32e.png";